module.exports = __webpack_public_path__ + "7275e5226fba7b21c727eb9d3eb58c0a.MP3";